//TODO update objects with teams token infos later

export interface IToken {
    access_token: string;
    refresh_token: string;
    token_type: string;
    id_token: string;
  }

  export interface IPublicKey {
    keys: [{
      kid: string;
      kty: string;
      alg: string;
      use: string;
      n: string;
      e: string;
      x5c: string[];
      x5t: string;
    }];
  }

  //TODO check
  export interface IJWTTokenPayload {
    jti: string;
    exp: number;
    nbf: number;
    iat: number;
    iss: string;
    aud: string;
    sub: string;
    typ: string;
    azp: string;
    uid: string;
    auth_time: number;
    session_state: string;
    acr: string;
    allowed_origins: string[];
    realm_access: any;
    resource_access: any;
    scope: string;
    email_verified: boolean;
    name: string;
    preferred_username: string;
    phone_number: string;
    given_name: string;
    family_name: string;
    email: string;
    rid: string;
    // should be specified by caller
    // authorities: L3_AUTHORITIES[];
    authorities: any[];
    did: string;
  }

  export interface IJWTToken {
    header: {
      alg: string;
      typ: string;
      kid: string;
    };
    payload: IJWTTokenPayload;
    encoded: any;
  }

  export class UserInfo {
    display_name!: string;
    authorities!: string[];
    domainId!: string;
    userId!: string;
    email!: string;
    phone_number!: string;
  }

